import React from 'react'
import { connect } from 'react-redux'
import { RotateModul } from '../RotateModul'
import styled from 'styled-components'
import PremiumIcon from '../PremiumIcon'
import { COLORS } from '../../../../Utils/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Language } from '../../../../Utils/Translation'
import { getUrlVar } from '../../../../Utils/utils'
import { detectBrowser } from '../../../../Utils/pojemnikApi/utils'

const CurrentLanguage = Language(getUrlVar('language'))


const Border = styled.div`
    width: 100%;
    height: 100%;

    @keyframes pencil{
	    0%{left: 0px}
	    60%{left: 12px}
	}

    .layer-index {
      display: none;
      position: absolute;
      top: -36px;
      height: 35px;
      left: -1px;
      /* min-width: 200px; */
      transition: .5s;
      opacity: 1;
    }

    .pencil-edit {
        position: relative;
        transform-origin: center;
        animation: 2s linear infinite both pencil;
        margin-left: ${props => props.editing ? '10px' : ''};
    }

    & > div {
        width:100%;
        height:100%;
    }
    
    .bordered {
        box-shadow: 0 0 0 ${props => detectBrowser().toLowerCase() === 'safari' ? 1 : 1 / (props.scale)}px ${COLORS.deepBlue};
        /* outline: ${props => 1 / (props.scale)}px solid ${COLORS.deepBlue}; */
    }
    .bordered-inner-text {
        width:100%;
        height:100%;
        /* outline: 1px solid ${COLORS.deepBlue}; */
        box-shadow: 0 0 0 ${props => detectBrowser().toLowerCase() === 'safari' ? 1 : 1 / (props.scale)}px ${COLORS.deepBlue};
        transition: color .25s ease, background-color .25s ease, border-color .25s ease;
    }
    .not-bordered{
        width:100%;
        height:100%;
    }

    .bordered .layer-index, .bordered-inner-text .layer-index {
        display: flex;
        color: #ffffff;
        z-index: 1;
    } 


    .bordered .layer-index .index, .bordered-inner-text .layer-index .index{
        /* background: #85B5E2;
        width: 50%;
        text-align: center;
        padding: 5px; */
        background: ${COLORS.deepBlue};
        text-align: center;
        padding: 3px 20px 0;
        height: 35px;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 12px;
    }
    /* .bordered .layer-index .layer {
        background: #80CDF7;
        width: 50%;
        text-align: center;
        padding: 5px;
    } */
`


class SelectedBorder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            borderStyle: {
                padding: null
            }
        }
    }

    componentDidMount() {
        this.setState({
            borderStyle: this.getBorderStyle()
        })
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            borderStyle: this.getBorderStyle()
        })
    }




    getBorderStyle() {

    }

    renderIndex() {
        // const editingThisCaption = (!this.props.editingText || (this.props.editingText && this.props.editingCaptionIndex != this.props.index))
        // const captionsNotEdit = !this.props.editingText

        if (this.props.captionSelectedArray.length < 2 && this.props.selected) {
            const mobileViewScale = this.props.mobileViewScale ? 1 / this.props.mobileViewScale : 1
            const layerIndesStyles = {
                transform: `scale(${mobileViewScale})`,
                transformOrigin: 'left bottom'
            }
            return (
                <div className={'layer-index'} style={layerIndesStyles}>
                    <div className={'index'} style={{ backgroundColor: this.props.isPremiumElem ? 'rgba(206, 109, 237, 1)' : '' }} >
                        {this.props.isPremiumElem &&
                            <UI.symbol onClick={(e) => Wix.Dashboard.openBillingPage()} name="premiumLarge" style={{ marginRight: 5 }} />
                        }
                        {/* <span>{this.props.captionType}</span>: Element {this.props.index + 1}  */}
                        <span>{this.props.captionType}</span> {this.props.editingText && this.props.selected && <FontAwesomeIcon className={'pencil-edit'} icon={'pencil-alt'} />}
                        {
                            this.props.cropButton
                        }
                    </div>
                </div>
            )
        }
    }



    render() {
        const borderStyle = {}
        if (this.props.isCountdownInEditor) {
            borderStyle.display = 'flex'
            borderStyle.alignItems = 'center'
        }
        const borderedClassName = this.props.isCountdownInEditor ? 'bordered-inner-text' : 'bordered'
        return (
            <Border {...this.state.borderStyle} editing={this.props.editingText && this.props.selected} scale={this.props.mobileViewScale || 1} className={'selected-border'} >
                <div
                    className={(!this.props.previewSlide && this.props.selected) ? borderedClassName : 'not-bordered'}
                    style={borderStyle}
                >
                    {this.renderIndex()}
                    {this.props.children}
                </div>
            </Border>
        )
    }
}


function mapStateToProps(state) {
    return {
        editingText: state.menuReducer.editingText,
        captionSelectedArray: state.menuReducer.captionSelectedArray,
        slideIndex: state.slideReducer.index,
        editingCaptionIndex: state.menuReducer.editingCaptionIndex,
        previewSlide: state.menuReducer.previewSlide,
    }
}

export default connect(mapStateToProps)(SelectedBorder)